<div class="form-input-container" [style]="style">
    @if (required) {
        <label> {{label}} *</label>
    }
    @else {
        <label> {{label}}</label>
    }

    <!-- TODO: padding-left should be conditional based on whether there's left overlay or right overlay -->
    <div style="position:relative;">
        <div style="position:relative; align-items: center;">
            @if (this.type == TextModes.CurrencyUSD || this.type == TextModes.Percent) {
                @if (this.type == TextModes.CurrencyUSD) {
                    <div class="leftOverlay">$</div>
                    <input type="text" style="padding-left:17px;" [value]="defaultText" [placeholder]="hint" [disabled]="readonly || disabled" [class.is-invalid]="!isValid" [attr.tid]="testId" id="{{myId}}" #textbox [(ngModel)]="boundValue" (keyup)="_handle_onKeyUp($event)" [style.width]="inputWidth" (blur)="handle_onBlur($event)" />
                }
                @if (this.type == TextModes.Percent) {
                    <div class="rightOverlay">%</div>
                    <input type="text" [value]="defaultText" [placeholder]="hint" [disabled]="readonly || disabled" [class.is-invalid]="!isValid" class="form-input" [attr.tid]="testId" id="{{myId}}" #textbox [(ngModel)]="boundValue" (keyup)="_handle_onKeyUp($event)" [style.width]="inputWidth" (blur)="handle_onBlur($event)" />
                }
            }
            @else {
                @if (this.type != TextModes.Password) {
                    <!--add a conditional class-->
                    <input type="text" [value]="defaultText" [placeholder]="hint" [disabled]="readonly || disabled" [class.is-invalid]="!isValid" class="form-input floatText" [attr.tid]="testId" id="{{myId}}" #textbox [(ngModel)]="boundValue" (keyup)="_handle_onKeyUp($event)" [style.width]="inputWidth" (blur)="handle_onBlur($event)" />
                }
                @if (this.type == TextModes.Password) {
                    <input type="password" class="floatText" [disabled]="readonly || disabled" [attr.tid]="testId" id="{{myId}}" #textbox [(ngModel)]="boundValue" (keyup)="_handle_onKeyUp($event)" [style]="style" [style.width]="inputWidth" (blur)="handle_onBlur($event)" />
                }
            }
        </div>
        @if (helpText != '') {
            <mat-icon
            class="iconOverlay"
            matTooltip="{{ helpText }}"
            [ngStyle]="{ color: '#6b7475' }"
            >info</mat-icon
            >
            <!-- <div style="position: absolute; top: -12px; right: -12px; background-color: #ffffff;"  title="{{ helpText }}">
                <app-icon-test [type]="IconType.Info" [size]="24" [ngStyle]="{ color: '#6b7475' }" matTooltip="{{ helpText }}"></app-icon-test>
            </div> -->
        }
        <div class="validation-msg" [hidden]="isValid">{{validationMsg}}</div>
    </div>
  
</div>